import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static values = { since: String }
  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 60_000)
  }
  disconnect() { clearInterval(this.timer) }
  tick() {
    const elapsed = Math.floor((Date.now() - new Date(this.sinceValue).getTime()) / 60_000)
    const h = Math.floor(elapsed / 60)
    const m = elapsed % 60
    this.element.textContent = h ? `${h}h ${m}m` : `${m}m`
  }
}
